<template>
  <div class="coreProductInfo">
    <img src="/status/ecfd4938-1949-4af7-a8af-94c2e0791651.png" style="height: 800px;
      object-fit: cover;width: 100%">
    <div class="box_middle_list">
      <div class="core_top">
        <span @click="black" style="cursor: pointer;font-size: 50px">返回上一页</span>
      </div>
      <div class="list_list">
        <div class="list_left">
          <img :src="list.img">
          <el-image
              class="imgInfo" v-if="list.imgInfo" :src="list.imgInfo"
              >
          </el-image>
        </div>
        <div class="list_right">
          <div class="name">{{list.name}}</div>
          <div class="info">产品介绍：
            <div style="margin-top: 10px" v-html="list.info"></div></div>
          <div class="btn_list">
            <div class="phone">
              <img src="/status/dianhua.png">
              <div>400-022-9558</div>
            </div>
            <div class="sub" @click="makeCall">联系我们</div>
          </div>
        </div>
      </div>
      <div class="info_info">
        <div class="info_text">产品详情</div>
        <div class="info_html" v-html="list.info"></div>
      </div>
    </div>
  </div>
</template>

<script>

import {coreProductList} from "@/views/mock";

export default {
  name: "coreProductInfo",
  data(){
    return{
      list:{},
      phoneNumber:'400-022-9558'
    }
  },
  created(){
    let arr = coreProductList.flat().filter((item)=>{
      return item.id == this.$route.query.id
    })
    this.list = arr[0]
  },
  methods:{
    makeCall() {
      window.location.href = `tel:${this.phoneNumber}`;
    },
    black(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
.coreProductInfo{
  padding-bottom: 50px;
  .box_middle_list{
    display: flex;
    align-items: center;
    flex-direction: column;
    .core_top{
      width: 1400px;
      border-bottom: 2px solid rgb(227,227,227);
      text-align: right;
      padding: 34px 0;
    }
    .list_list{
      width: 1500px;
      margin-top: 30px;
      display: flex;
      .list_left{
        border: 1px solid rgb(217,217,217);
        height: max-content;
        padding: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        img{
          width: 500px;
        }
        .imgInfo{
          position: absolute;
          left: 70px;
          top: 70px;
          width: 364px;
        }
      }
      .list_right{
        margin-left: 40px;
        .name{
          font-size: 54px;
        }
        .info{
          margin-top: 20px;
          font-size: 45px;
          color: #9B9B9B;
        }
      }
      .btn_list{
        display: flex;
        font-size: 48px;
        margin-top: 40px;
        .phone{
          border: 2px solid rgb(63,170,249);
          width:450px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 30px 20px;
          color: rgb(63,170,249);
          border-radius: 14px;
          font-weight: bold;

          img{
            width: 52px;
            margin-right: 4px;
          }
        }
        .sub{
          padding: 30px 20px;
          background: rgb(63,170,249);
          color: white;
          text-align: center;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 350px;
          margin-left: 60px;
        }
      }
    }
    .info_info{
      width: 1500px;
      margin-top: 50px;
      border: 2px solid rgb(227,227,227);
      .info_text{
        border-top: 8px solid rgb(63,170,249);
        border-right: 1px solid rgb(227,227,227);
        padding: 30px 0;
        color: #2A5caa;
        width: 350px;
        font-size: 54px;
        text-align: center;
      }
      .info_html{
        border-top: 1px solid rgb(227,227,227);
        padding: 20px;
        font-size: 50px;
      }
    }
  }
}
</style>
